export default "__VITE_PUBLIC_ASSET__1dba7008__"